module.exports = __webpack_public_path__ + "static/media/img1-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img1-4.png
// module id = 1700
// module chunks = 3